if (!customElements.get('startpakke-form')) {
  class StartpakkeForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.summary = this.querySelector('.startpakke__summary');
      this.finalButton = this.form?.querySelector('[type="submit"]');

      this.errorMessage = this.summary?.querySelector(
        '.startpakke__error-message'
      );

      this.cart =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');

      this.selectedVariants = {
        mattress: {
          id: null,
          price: 0,
          title: '',
          quantity: 1
        },
        duvet: {
          id: null,
          price: 0,
          title: '',
          quantity: 1
        },
        pillow: {
          id: null,
          price: 0,
          title: '',
          quantity: 1
        }
      };

      this.originalMattressOptions = [];
      this.mattressProductCache = {};
      this.currentMattressType = 'box';
      this.isSubmitting = false;

      // Load translations from data block
      const translationsElement = document.getElementById('startpakke-translations');
      this.translations = translationsElement ? JSON.parse(translationsElement.textContent) : {};

      if (!this.form || !this.summary || !this.finalButton) {
        console.error(
          'StartpakkeForm: Required elements not found'
        );
        return;
      }

      this.init();
    }


    /* =========================================================
       INITIALISE
       ========================================================= */

    init() {
      this.setupMattressTypeSelector();
      this.setupVariantSelectors();
      this.initializeSelections();

      this.form.addEventListener(
        'submit',
        this.onFormSubmit.bind(this)
      );

      this.setupQuantityButtons();
      this.updateFinalButtonState();

      const mattressSelect = this.querySelector(
        'select[data-product-id-box]'
      );

      const envelopeRadio = this.querySelector(
        'input[name="mattress-type"][value="envelope"]'
      );

      if (
        envelopeRadio &&
        mattressSelect?.dataset.productIdEnvelope
      ) {
        envelopeRadio.checked = true;

        envelopeRadio.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    }


    /* =========================================================
       INITIAL SELECTIONS
       ========================================================= */

    initializeSelections() {
      const mattressSelect =
        this.querySelector(
          'select[data-product-id-box]'
        );

      if (
        mattressSelect &&
        mattressSelect.options.length
      ) {
        const option =
          mattressSelect.options[
            mattressSelect.selectedIndex
          ];

        this.setSelectedVariant(
          'mattress',
          option
        );
      }

      const selects =
        this.querySelectorAll(
          'select[data-product-id]'
        );

      selects.forEach((select) => {
        if (!select.options.length) {
          return;
        }

        const productType =
          this.getProductType(select);

        if (!productType) {
          return;
        }

        const option =
          select.options[
            select.selectedIndex
          ];

        this.setSelectedVariant(
          productType,
          option
        );
      });

      this.updateSummaryTotals();
    }


    /* =========================================================
       MATTRESS TYPE SELECTOR
       ========================================================= */

    setupMattressTypeSelector() {
      const radios =
        this.querySelectorAll(
          'input[name="mattress-type"]'
        );

      const select =
        this.querySelector(
          'select[data-product-id-box]'
        );

      if (!radios.length || !select) {
        return;
      }

      /*
       * Store the original Boxmadras options.
       */
      this.originalMattressOptions =
        Array.from(select.options).map(
          (option) => ({
            value: option.value,
            text: option.textContent.trim(),
            price: option.dataset.price || '0'
          })
        );

      const checked =
        this.querySelector(
          'input[name="mattress-type"]:checked'
        );

if (checked) {
  this.currentMattressType =
    checked.value;
}

this.updateMattressImage(
  this.currentMattressType
);

radios.forEach((radio) => {
        radio.addEventListener(
          'change',
          () => {
            this.switchMattressType(
              radio.value,
              select
            );
          }
        );
      });

      /*
       * Mattress size change.
       */
      select.addEventListener(
        'change',
        () => {
          const option =
            select.options[
              select.selectedIndex
            ];

          if (!option) {
            return;
          }

          this.setSelectedVariant(
            'mattress',
            option
          );

          this.updateSummaryTotals();
          this.updateFinalButtonState();
        }
      );
    }


    /* =========================================================
       SWITCH BOXMADRASS / TOPMADRASS
       ========================================================= */

    async switchMattressType(
      type,
      select
    ) {
      if (
        type !== 'box' &&
        type !== 'envelope'
      ) {
        return;
      }

      this.currentMattressType = type;

this.updateMattressImage(type);

if (type === 'box') {
        this.restoreBoxMattressOptions(
          select
        );

        this.updateMattressCardTitle(
          'box'
        );

        this.selectFirstMattressVariant(
          select
        );

        return;
      }

      await this.loadEnvelopeMattressOptions(
        select
      );
    }


    /* =========================================================
       RESTORE BOXMADRASS OPTIONS
       ========================================================= */

    restoreBoxMattressOptions(
      select
    ) {
      select.innerHTML = '';

      this.originalMattressOptions.forEach(
        (optionData) => {
          const option =
            document.createElement(
              'option'
            );

          option.value =
            optionData.value;

          option.textContent =
            optionData.text;

          option.dataset.price =
            String(optionData.price);

          option.dataset.mattressType =
            'box';

          select.appendChild(option);
        }
      );
    }


    /* =========================================================
       LOAD TOPMADRASS OPTIONS
       ========================================================= */

    async loadEnvelopeMattressOptions(
      select
    ) {
      /*
       * The Topmadras product handle is already
       * supplied to the page by the Liquid mapping.
       *
       * We retrieve it from the product data
       * attribute on the select.
       */
      const handle =
        select.dataset.productHandle;

      /*
       * If the Liquid does not provide the handle,
       * fall back to the known product handle.
       */
      const productHandle =
        handle ||
        'kuvert-betraek-med-lynlas';

      if (
        this.mattressProductCache[
          productHandle
        ]
      ) {
        this.populateEnvelopeOptions(
          select,
          this.mattressProductCache[
            productHandle
          ]
        );

        return;
      }

      try {
        const root =
          window.Shopify?.routes?.root ||
          '/';

        const response =
          await fetch(
            `${root}products/${productHandle}.js`
          );

        if (!response.ok) {
          throw new Error(
            `Product request failed: ${response.status}`
          );
        }

        const product =
          await response.json();

        if (
          !product ||
          !Array.isArray(
            product.variants
          ) ||
          !product.variants.length
        ) {
          throw new Error(
            'No Topmadras variants found'
          );
        }

        this.mattressProductCache[
          productHandle
        ] = product;

        this.populateEnvelopeOptions(
          select,
          product
        );
      } catch (error) {
        console.error(
          'StartpakkeForm: Could not load Topmadras:',
          error
        );

        this.showError(
          this.translations.error_mattress_load || 'Could not load mattress sizes. Please try again.'
        );
      }
    }


    /* =========================================================
       POPULATE TOPMADRASS OPTIONS
       ========================================================= */

    populateEnvelopeOptions(
      select,
      product
    ) {
      select.innerHTML = '';

      product.variants.forEach(
        (variant) => {
          const option =
            document.createElement(
              'option'
            );

          option.value =
            String(variant.id);

          option.textContent =
            variant.title;

          option.dataset.price =
            String(variant.price);

          option.dataset.mattressType =
            'envelope';

          select.appendChild(option);
        }
      );

      if (!select.options.length) {
        this.showError(
          this.translations.error_no_sizes || 'No mattress sizes are available.'
        );

        return;
      }

      this.updateMattressCardTitle(
        'envelope',
        product.title
      );

      this.selectFirstMattressVariant(
        select
      );
    }


    /* =========================================================
       SELECT FIRST MATTRESS VARIANT
       ========================================================= */

    selectFirstMattressVariant(
      select
    ) {
      if (!select.options.length) {
        return;
      }

      select.selectedIndex = 0;

      const option =
        select.options[
          select.selectedIndex
        ];

      this.setSelectedVariant(
        'mattress',
        option
      );

      this.updateSummaryTotals();
      this.updateFinalButtonState();
    }


    /* =========================================================
       UPDATE MATTRESS CARD TITLE
       ========================================================= */

    updateMattressCardTitle(
      type,
      title = ''
    ) {
      const card =
        this.querySelector(
          '[data-product-type="mattress"]'
        );

      if (!card) {
        return;
      }

      const heading =
        card.querySelector(
          '.startpakke__card-title'
        );

      if (!heading) {
        return;
      }

      if (type === 'envelope') {
        heading.textContent =
          title ||
          (this.translations.label_envelope || 'Envelope Mattress Protector');
      } else {
        heading.textContent =
          this.translations.label_box || 'Box Mattress Protector';
      }
    }
/* =========================================================/* =========================================================
   UPDATE MATTRESS IMAGE
   ========================================================= */

updateMattressImage(type) {
  const card = this.querySelector(
    '[data-product-type="mattress"]'
  );

  if (!card) {
    return;
  }

  const boxImage = card.querySelector(
    '.startpakke__mattress-image--box'
  );

  const envelopeImage = card.querySelector(
    '.startpakke__mattress-image--envelope'
  );

  if (!boxImage || !envelopeImage) {
    console.error(
      'StartpakkeForm: Mattress images not found'
    );
    return;
  }

  if (type === 'envelope') {
    boxImage.style.display = 'none';
    envelopeImage.style.display = 'block';
  } else {
    boxImage.style.display = 'block';
    envelopeImage.style.display = 'none';
  }
}

    /* =========================================================
       OTHER VARIANT SELECTORS
       ========================================================= */

    setupVariantSelectors() {
      const selects =
        this.querySelectorAll(
          'select[data-product-id]'
        );

      selects.forEach((select) => {
        select.addEventListener(
          'change',
          () => {
            const option =
              select.options[
                select.selectedIndex
              ];

            if (!option) {
              return;
            }

            const productType =
              this.getProductType(
                select
              );

            if (!productType) {
              return;
            }

            this.setSelectedVariant(
              productType,
              option
            );

            this.updateSummaryTotals();
            this.updateFinalButtonState();
          }
        );
      });
    }


    /* =========================================================
       GET PRODUCT TYPE
       ========================================================= */

    getProductType(select) {
      const parent =
        select.closest(
          '[data-product-type]'
        );

      return (
        parent?.dataset.productType ||
        null
      );
    }


    /* =========================================================
       SET SELECTED VARIANT
       ========================================================= */

    setSelectedVariant(
      productType,
      option
    ) {
      if (
        !option ||
        !option.value
      ) {
        this.selectedVariants[
          productType
        ] = {
          id: null,
          price: 0,
          title: ''
        };

        this.updateCardPrice(
          productType,
          0
        );

        this.updateSummaryItem(
          productType,
          '',
          0
        );

        return;
      }

      const variantId =
        parseInt(
          option.value,
          10
        );

      const variantPrice =
        parseInt(
          option.dataset.price ||
            '0',
          10
        );

      const variantTitle =
        option.textContent.trim();

      /*
       * Update variant properties while
       * preserving quantity.
       */
      this.selectedVariants[
        productType
      ].id = variantId;

      this.selectedVariants[
        productType
      ].price = variantPrice;

      this.selectedVariants[
        productType
      ].title = variantTitle;

      /*
       * Ensure quantity exists.
       * If missing or invalid, reset to 1.
       */
      if (
        typeof (
          this.selectedVariants[
            productType
          ].quantity
        ) !== 'number' ||
        isNaN(
          this.selectedVariants[
            productType
          ].quantity
        ) ||
        this.selectedVariants[
          productType
        ].quantity < 1
      ) {
        this.selectedVariants[
          productType
        ].quantity = 1;
      }

      /*
       * Update the price displayed directly
       * underneath the product selector.
       */
      this.updateCardPrice(
        productType,
        variantPrice
      );

      /*
       * Update the summary at the bottom.
       */
      this.updateSummaryItem(
        productType,
        variantTitle,
        variantPrice
      );
    }


    /* =========================================================
       UPDATE PRODUCT CARD PRICE
       ========================================================= */

    updateCardPrice(
      productType,
      variantPrice
    ) {
      const priceElement =
        this.querySelector(
          `#${productType}-price`
        );

      if (!priceElement) {
        return;
      }

      if (
        !variantPrice ||
        Number.isNaN(
          Number(variantPrice)
        )
      ) {
        return;
      }

      priceElement.textContent =
        this.formatPrice(
          variantPrice
        );
    }


    /* =========================================================
       UPDATE SUMMARY ITEM
       ========================================================= */

    updateSummaryItem(
      productType,
      variantTitle,
      variantPrice
    ) {
      const sizeElement =
        this.summary.querySelector(
          `#${productType}-summary-size`
        );

      const priceElement =
        this.summary.querySelector(
          `#${productType}-summary-price`
        );

      const qtyLabel =
        this.summary.querySelector(
          `.startpakke__qty-label[data-product-type="${productType}"]`
        );

      if (sizeElement) {
        sizeElement.textContent =
          variantTitle
            ? this.extractSizeFromTitle(
                variantTitle
              )
            : '—';
      }

      if (priceElement) {
        priceElement.textContent =
          variantPrice
            ? this.formatPrice(
                variantPrice
              )
            : '—';
      }

      if (qtyLabel) {
        let quantity =
          this.selectedVariants[
            productType
          ]?.quantity || 1;

        /*
         * Normalize invalid quantities.
         */
        if (
          typeof quantity !== 'number' ||
          isNaN(quantity) ||
          quantity < 1
        ) {
          quantity = 1;
        }

        qtyLabel.textContent =
          quantity > 1
            ? `Qty: ${quantity} × `
            : '';
      }
    }


    /* =========================================================
       EXTRACT SIZE
       ========================================================= */

    extractSizeFromTitle(
      title
    ) {
      if (!title) {
        return '—';
      }

      const match =
        title.match(
          /\d+\s*x\s*\d+(?:\s*x\s*\d+)?\s*(?:cm)?/i
        );

      return match
        ? match[0]
        : title;
    }


    /* =========================================================
       UPDATE TOTALS
       ========================================================= */

    updateSummaryTotals() {
      /*
       * Ensure quantities are valid numbers.
       * Normalize to 1 if undefined/NaN.
       */
      const getMattressQty = () => {
        const qty =
          this.selectedVariants
            .mattress.quantity;
        return (
          typeof qty === 'number' &&
          !isNaN(qty) &&
          qty >= 1
        )
          ? qty
          : 1;
      };

      const getDuvetQty = () => {
        const qty =
          this.selectedVariants
            .duvet.quantity;
        return (
          typeof qty === 'number' &&
          !isNaN(qty) &&
          qty >= 1
        )
          ? qty
          : 1;
      };

      const getPillowQty = () => {
        const qty =
          this.selectedVariants
            .pillow.quantity;
        return (
          typeof qty === 'number' &&
          !isNaN(qty) &&
          qty >= 1
        )
          ? qty
          : 1;
      };

      const mattressPrice =
        (Number(
          this.selectedVariants
            .mattress.price
        ) || 0) * getMattressQty();

      const duvetPrice =
        (Number(
          this.selectedVariants
            .duvet.price
        ) || 0) * getDuvetQty();

      const pillowPrice =
        (Number(
          this.selectedVariants
            .pillow.price
        ) || 0) * getPillowQty();

      const subtotal =
        mattressPrice +
        duvetPrice +
        pillowPrice;

      /*
       * Display calculation only.
       *
       * Shopify remains responsible for
       * applying the actual 10% discount.
       */
      const discount =
        subtotal * 0.10;

      const total =
        subtotal - discount;

      const subtotalElement =
        this.summary.querySelector(
          '#subtotal-amount'
        );

      const discountElement =
        this.summary.querySelector(
          '#discount-amount'
        );

      const totalElement =
        this.summary.querySelector(
          '#total-amount'
        );

      if (subtotalElement) {
        subtotalElement.textContent =
          subtotal > 0
            ? this.formatPrice(
                subtotal
              )
            : '—';
      }

      if (discountElement) {
        discountElement.textContent =
          subtotal > 0
            ? `−${this.formatPrice(
                discount
              )}`
            : '—';
      }

      if (totalElement) {
        totalElement.textContent =
          subtotal > 0
            ? this.formatPrice(
                total
              )
            : '—';
      }
    }


    /* =========================================================
       FORMAT PRICE
       ========================================================= */

    formatPrice(
      priceInCents
    ) {
      const currency =
        window.Shopify?.currency
          ?.active ||
        'DKK';

      return new Intl.NumberFormat(
        'da-DK',
        {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      ).format(
        Number(
          priceInCents
        ) / 100
      );
    }


    /* =========================================================
       BUTTON STATE
       ========================================================= */

    updateFinalButtonState() {
      const ready =
        Boolean(
          this.selectedVariants
            .mattress.id &&
          this.selectedVariants
            .duvet.id &&
          this.selectedVariants
            .pillow.id
        );

      this.finalButton.disabled =
        !ready;

      this.finalButton.setAttribute(
        'aria-disabled',
        String(!ready)
      );
    }


    /* =========================================================
       QUANTITY BUTTONS SETUP
       ========================================================= */

    setupQuantityButtons() {
      const minusButtons =
        this.querySelectorAll(
          '.startpakke__quantity-btn--minus'
        );

      const plusButtons =
        this.querySelectorAll(
          '.startpakke__quantity-btn--plus'
        );

      minusButtons.forEach((btn) => {
        btn.addEventListener(
          'click',
          (e) => {
            e.preventDefault();
            const productType =
              btn.dataset.productType;
            this.subtractQuantity(
              productType
            );
          }
        );
      });

      plusButtons.forEach((btn) => {
        btn.addEventListener(
          'click',
          (e) => {
            e.preventDefault();
            const productType =
              btn.dataset.productType;
            this.addQuantity(
              productType
            );
          }
        );
      });
    }


    /* =========================================================
       ADD QUANTITY
       ========================================================= */

    addQuantity(productType) {
      if (!this.selectedVariants[productType]) {
        return;
      }

      /*
       * Ensure quantity is a valid number.
       * Normalize undefined/NaN to 1.
       */
      let quantity =
        this.selectedVariants[
          productType
        ].quantity;

      if (
        typeof quantity !== 'number' ||
        isNaN(quantity) ||
        quantity < 1
      ) {
        quantity = 1;
      }

      this.selectedVariants[productType]
        .quantity = quantity + 1;

      this.updateQuantityDisplay(
        productType
      );

      this.updateSummaryTotals();
    }


    /* =========================================================
       SUBTRACT QUANTITY
       ========================================================= */

    subtractQuantity(productType) {
      if (!this.selectedVariants[productType]) {
        return;
      }

      /*
       * Ensure quantity is a valid number.
       * Normalize undefined/NaN to 1.
       */
      let quantity =
        this.selectedVariants[
          productType
        ].quantity;

      if (
        typeof quantity !== 'number' ||
        isNaN(quantity) ||
        quantity < 1
      ) {
        quantity = 1;
      }

      if (quantity <= 1) {
        return;
      }

      this.selectedVariants[productType]
        .quantity = quantity - 1;

      this.updateQuantityDisplay(
        productType
      );

      this.updateSummaryTotals();
    }


    /* =========================================================
       UPDATE QUANTITY DISPLAY
       ========================================================= */

    updateQuantityDisplay(productType) {
      const quantitySpan =
        this.querySelector(
          `.startpakke__quantity-value[data-product-type="${productType}"]`
        );

      if (quantitySpan) {
        let quantity =
          this.selectedVariants[
            productType
          ]?.quantity;

        /*
         * Normalize invalid quantities to 1.
         */
        if (
          typeof quantity !== 'number' ||
          isNaN(quantity) ||
          quantity < 1
        ) {
          quantity = 1;
          /*
           * Repair state if it was corrupted.
           */
          this.selectedVariants[
            productType
          ].quantity = quantity;
        }

        quantitySpan.textContent =
          String(quantity);
      }
    }


    /* =========================================================
       SUBMIT
       ========================================================= */

    onFormSubmit(
      event
    ) {
      event.preventDefault();

      if (this.isSubmitting) {
        return;
      }

      this.addAllToCart();
    }


    /* =========================================================
       ADD PRODUCTS TO CART
       ========================================================= */

    addAllToCart() {
      const mattress =
        this.selectedVariants
          .mattress;

      const duvet =
        this.selectedVariants
          .duvet;

      const pillow =
        this.selectedVariants
          .pillow;

      if (
        !mattress.id ||
        !duvet.id ||
        !pillow.id
      ) {
        this.showError(
          'Vælg venligst alle produkter.'
        );

        return;
      }

      this.isSubmitting = true;

      this.finalButton.disabled =
        true;

      this.finalButton.classList.add(
        'loading'
      );

      const formData =
        new FormData();

      formData.append(
        'items[0][id]',
        mattress.id
      );

      formData.append(
        'items[0][quantity]',
        String(
          mattress.quantity || 1
        )
      );

      formData.append(
        'items[1][id]',
        duvet.id
      );

      formData.append(
        'items[1][quantity]',
        String(
          duvet.quantity || 1
        )
      );

      formData.append(
        'items[2][id]',
        pillow.id
      );

      formData.append(
        'items[2][quantity]',
        String(
          pillow.quantity || 1
        )
      );

      /*
       * Ask the theme cart component which
       * sections it needs to refresh.
       */
      if (this.cart) {
        const sections =
          this.cart.getSectionsToRender?.() ||
          [];

        if (sections.length) {
          formData.append(
            'sections',
            sections
              .map(
                (section) =>
                  section.id
              )
              .join(',')
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );
        }

        this.cart.setActiveElement?.(
          this.finalButton
        );
      }

      const config =
        fetchConfig(
          'javascript'
        );

      config.headers[
        'X-Requested-With'
      ] = 'XMLHttpRequest';

      delete config.headers[
        'Content-Type'
      ];

      config.body = formData;

      fetch(
        routes.cart_add_url,
        config
      )
        .then(
          (response) => {
            if (!response.ok) {
              throw new Error(
                `Cart request failed: ${response.status}`
              );
            }

            return response.json();
          }
        )
        .then(
          (response) => {
            if (response.status) {
              this.showError(
                response.description ||
                  (this.translations.error_generic || 'An error occurred. Please try again.')
              );

              return;
            }

            if (this.cart) {
              this.cart.renderContents?.(
                response
              );
            }

            this.resetSelections();
          }
        )
        .catch(
          (error) => {
            console.error(
              'StartpakkeForm: Cart error',
              error
            );

            this.showError(
              this.translations.error_generic_later || 'An error occurred. Please try again later.'
            );
          }
        )
        .finally(
          () => {
            this.isSubmitting =
              false;

            this.finalButton.classList.remove(
              'loading'
            );

            this.updateFinalButtonState();
          }
        );
    }


    /* =========================================================
       RESET
       ========================================================= */

    resetSelections() {
      /*
       * Sync state from current dropdown
       * selections instead of clearing.
       * This keeps visible selections
       * in sync with internal state.
       */
      this.syncSelectionsFromDOM();

      this.updateFinalButtonState();
    }


    /* =========================================================
       SYNC SELECTIONS FROM DOM
       ========================================================= */

    syncSelectionsFromDOM() {
      /*
       * Reset quantities to 1 while
       * preserving variant selections
       * from dropdowns.
       */
      this.selectedVariants = {
        mattress: {
          id: null,
          price: 0,
          title: '',
          quantity: 1
        },
        duvet: {
          id: null,
          price: 0,
          title: '',
          quantity: 1
        },
        pillow: {
          id: null,
          price: 0,
          title: '',
          quantity: 1
        }
      };

      /*
       * Read mattress selection from DOM.
       */
      const mattressSelect =
        this.querySelector(
          'select[data-product-id-box]'
        );

      if (
        mattressSelect &&
        mattressSelect.options.length
      ) {
        const option =
          mattressSelect.options[
            mattressSelect.selectedIndex
          ];

        if (option.value) {
          this.setSelectedVariant(
            'mattress',
            option
          );
        }
      }

      /*
       * Read duvet and pillow
       * selections from DOM.
       */
      const selects =
        this.querySelectorAll(
          'select[data-product-id]'
        );

      selects.forEach((select) => {
        if (!select.options.length) {
          return;
        }

        const productType =
          this.getProductType(select);

        if (!productType) {
          return;
        }

        const option =
          select.options[
            select.selectedIndex
          ];

        if (option.value) {
          this.setSelectedVariant(
            productType,
            option
          );
        }
      });

      /*
       * Reset quantity displays in DOM.
       */
      this.updateQuantityDisplay(
        'mattress'
      );

      this.updateQuantityDisplay(
        'duvet'
      );

      this.updateQuantityDisplay(
        'pillow'
      );

      /*
       * Recalculate summary.
       */
      this.updateSummaryTotals();
    }


    /* =========================================================
       ERROR
       ========================================================= */

    showError(
      message
    ) {
      if (!this.errorMessage) {
        return;
      }

      this.errorMessage.textContent =
        message;

      this.errorMessage.hidden =
        false;

      this.errorMessage.scrollIntoView(
        {
          behavior: 'smooth',
          block: 'nearest'
        }
      );
    }
  }

  customElements.define(
    'startpakke-form',
    StartpakkeForm
  );
}